
import { h, Fragment, render } from 'preact'
import { createPortal } from 'preact/compat'

import { initialSessionFromDom } from './../hooks/useSubmission'
import { useScreen } from './../hooks/useScreen'

import { json } from './../utility/dom'
import { removeQueryHash } from './../utility/url'

import { Screens, requireAdjustmentScreens, eoScreens } from './screens'


export function init() {
	const applyStagesEl = document.getElementById('apply-stages-form')
	const session = initialSessionFromDom()
	const stages = json('#form-stages')
	if (!stages || !applyStagesEl) return

	const initialStage = removeQueryHash(window.location.href)
		.replace(stages.apply, '')
		.replace(/^\//, '')
		.replace(/\/$/, '')

	applyStagesEl && render(
		createPortal(<App session={session} initialStage={initialStage} applyUrl={stages.apply} reviewUrl={stages.review} />, applyStagesEl), 
		document.body
	)
}


function App({ session, initialStage, applyUrl, reviewUrl }) {

	const initialScreens = {
		'adjustments' : 'RequireAdjustments1',
		'equal-opportunities' : (session.eoLinkExternal ? 'EqualOppsExternal' : 'EqualOpps1'),
	}

	const initialScreen = initialScreens[initialStage] || 'RequireAdjustments1'

	const { screen, goTo, goToUrl } = useScreen(initialScreen)

	const screens = {
		...requireAdjustmentScreens(goTo, goToUrl, session, applyUrl),
		...eoScreens(goTo, goToUrl, reviewUrl)
	}

	return <Screens screens={screens} currentScreen={screen} session={session} />
}


